var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h6',{staticClass:"subject"},[_vm._v(_vm._s(_vm.skill.title))]),_c('div',{staticClass:"percentage",attrs:{"data-percentage":_vm.percentage}},[_c('div',{staticClass:"skill-percen",style:('width:' + _vm.percentage + ';')})])])}
var staticRenderFns = []

export { render, staticRenderFns }